import React from "react";
import { Search, Bell, HelpCircle, ChevronDown } from "lucide-react";

export default function Topbar({ user }) {
  const u = user || { name: "Dr. Emily Carter", role: "BCBA, Clinical Director", avatar: "/generated/clinician_female.png" };
  return (
    <header className="sticky top-0 z-30 bg-white/85 backdrop-blur border-b border-slate-100">
      <div className="flex items-center gap-4 px-5 lg:px-7 h-[72px]">
        <div className="flex-1 max-w-[560px]">
          <div className="flex items-center gap-2.5 rounded-2xl bg-[#f2f6fc] border border-slate-100 px-4 py-2.5">
            <Search size={18} className="text-slate-400" />
            <input data-testid="topbar-search" placeholder="Search patients, families, notes, or resources…" className="flex-1 bg-transparent outline-none text-[14.5px] placeholder:text-slate-400" />
          </div>
        </div>
        <div className="hidden xl:block font-hand text-[19px] text-[#2f7bf0] leading-[0.9] text-center rotate-[-4deg]">Stronger Children<br />Brighter Tomorrows <span className="text-[#37a862]">♥</span></div>
        <div className="flex items-center gap-2">
          <button className="relative h-11 w-11 grid place-items-center rounded-full hover:bg-[#eef5ff] text-[#33425c]"><Bell size={20} /><span className="absolute top-2 right-2 h-4 min-w-4 px-1 grid place-items-center rounded-full bg-[#e23b3b] text-white text-[10px] font-bold">3</span></button>
          <button className="h-11 w-11 grid place-items-center rounded-full hover:bg-[#eef5ff] text-[#33425c]"><HelpCircle size={20} /></button>
          <div className="flex items-center gap-2.5 pl-2 cursor-pointer">
            <img src={u.avatar} alt={u.name} className="h-10 w-10 rounded-full object-cover ring-2 ring-white shadow" />
            <div className="hidden md:block leading-tight"><div className="text-[14px] font-bold text-[#10233f]">{u.name}</div><div className="text-[12px] text-slate-500">{u.role}</div></div>
            <ChevronDown size={16} className="text-slate-400" />
          </div>
        </div>
      </div>
    </header>
  );
}
